import isolationAccuracy from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/isolation_accuracy.jsx";
import isolationFpr from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/isolation_fpr.jsx";
import mappingRates from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/mapping_rates.jsx";
import sharedReadAccuracy from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/shared_read_accuracy.jsx";
import drachBenchmarks from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/drach_benchmarks.jsx";
import confusionMatrices from "../../../../content/posts/data-release-notes/rna-mod-validation-all5mer/confusion_matrices.jsx";
import * as React from 'react';
export default {
  isolationAccuracy,
  isolationFpr,
  mappingRates,
  sharedReadAccuracy,
  drachBenchmarks,
  confusionMatrices,
  React
};